import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { merge, get, clone, set, findIndex } from 'lodash';
import { getQueryString } from '../../../utils/common';
import moment from 'moment';
import { Icon, InputItem, Carousel, Modal, Toast, ActionSheet, Checkbox } from 'antd-mobile';
import { VDialogText } from '../../../components/dialog';
import { base64ToBlob, blobToFile, createCookie, readCookie, isVideoUrl } from '../../../utils/common';
import { getImgInfo, getDownloadQRCode, sendDownloadInfo } from '../idetail/action';
import { VBottomNav } from '../../../components/copyright/common';
import { Loading } from '../../../components/loading';
import Tloader from '../../../components/loader';
import Vfalls from '../../../components/falls';
import { TextDialog } from '../../../components/textDialog';
import { getSearchToutu, handleImgData, handleIndexData, setGalleryImgPraise } from './action';
import { getUploadToken } from '../upload/action';
import LazyLoad from 'vanilla-lazyload';
import { DownloadTip } from '../../../components/downloadTip';
import { _track } from '../../../utils/track';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { MINIPROGRAM_APPID } from '../../../utils/weixin';
import { Vh5Video } from '../../../components/videoPaler';
import './index.scss';
import emptyImg from '../../../img/empty.svg';
const CheckboxItem = Checkbox.CheckboxItem;
let selectIndex = 0;
let isEnter = false;
const CopyrightSearch = props => {
	let praiseState = true;
	let lazyLoadInstance = new LazyLoad({
		elements_selector: '.lazy',
		load_delay: 0
		// ... more custom settings?
	});
	let history = useHistory();
	let params = useParams();
	const mapStateToProps = state => {
		return {
			isUpdate: state.CopyrightBaseinfoReducers.isUpdate,
			baseInfo: state.CopyrightBaseinfoReducers.baseinfo,
			searchToutuData: state.CopyrightBaseinfoReducers.searchToutuData,
			globalSearchString: state.CopyrightBaseinfoReducers.globalSearchString
		};
	};
	const mapState = useCallback(mapStateToProps, []);
	const { baseInfo, isUpdate, searchToutuData = {}, globalSearchString } = useMappedState(mapState);
	let { totalCount = 0, pageIndex = 1, pageSize = 10, contents } = searchToutuData;
	let [resultType, setResultType] = useState(() => {
		return params.searchType ? parseInt(params.searchType, 10) : 1;
	});
	let [step, setStep] = useState(1);
	let [isDownload, setIsDownload] = useState(false);
	let [isDownloadTip, setIsDownloadTip] = useState(false);
	let [isTooBig, setIsTooBig] = useState(false);
	let [selectIndex, setSelectIndex] = useState(0);
	let [playerOptions, setPlayerOptions] = useState({});
	let defaultProps = handleImgData(contents);
	let dispatch = useDispatch();
	let location = useLocation();
	const [pageData, setPageData] = useState({
		activityType: 0, //2是集合相册, 1是单相册
		albumFinishAll: false, //数据是否全部请求完成
		totalCount: 0, //请求之后这个数不能为-1 ,如果为空是0
		isShowShare: false,
		sharedData: {},
		isShowQRcodeInstruction: false,
		QRContent: '',
		isShowDownload: false,
		isShowInstruction: false,
		isOpen: false,
		openUrl: ''
	});

	const [imgInfo, setImgInfo] = useState({
		id: '',
		contentId: '',
		type: 1,
		userId: 11610,
		userNickname: '4119昵称',
		key: '',
		thumbKey: '',
		picDescription: '',
		description: '',
		submitTime: 0,
		crDate: 0,
		lat: null,
		city: '',
		width: 600,
		height: 885,
		size: 32513,
		authorUserName: null,
		authorUserId: null,
		workTraceResps: []
	});
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let [effectFlag, setEffectFlag] = useState(1);
	let [changeTab, setChangeTab] = useState(false);
	let [searchStr, setSearchStr] = useState(get(props, 'location.state.globalSearchString', ''));
	let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
	let copyright_search = readCookie('copyright_search');
	let searchHistory = copyright_search ? JSON.parse(copyright_search) : [];
	let [searchHistoryList, setSearchHistoryList] = useState(searchHistory);
	userId = parseInt(userId || 0, 10);
	function reloadLazyLoad(lazyLoadInstance) {
		let lazys = document.getElementsByClassName('lazy');
		for (let i = 0, j = lazys.length; i < j; i++) {
			let ele = lazys[i];
			let clsName = ele.className;
			console.log(clsName);
//			if (clsName.indexOf('loaded') >= 0) {
				let newClassName = clsName.replace(/loaded/g, '');
				console.log('newClassName', newClassName);
				ele.setAttribute('class', newClassName);
				let newSrc = ele.getAttribute('data-src');
				// ele.removeAttribute("src");
				ele.setAttribute('src', newSrc);
//			}
		}
		lazyLoadInstance = new LazyLoad({
			elements_selector: '.lazy',
			load_delay: 300
			// ... more custom settings?
		});
		console.log(lazyLoadInstance, 'document.getElementsByClassName("lazy")', document.getElementsByClassName('lazy'));
		lazyLoadInstance && lazyLoadInstance.update(document.getElementsByClassName('lazy'));
	}
	function conditionSearch({ index, limit, type, text }) {
		_track({
			trackName: 'toutu_search_page',
			payload: {
				search_key: text || searchStr,
				page_action_name: 'search-submit'
			}
		});
		dispatch(
			getSearchToutu(
				{
					index,
					limit: 10,
					workType: type, //类型：1 全部 2：活动 3：图片 4：视频"
					tag: text || searchStr,
					userId
				},
				() => {
					reloadLazyLoad(lazyLoadInstance);
					//			let lazys = document.getElementsByClassName("lazy");
					//			for (let i = 0 , j = lazys.length; i < j;i++) {
					//				let ele = lazys[i];
					//				let clsName = ele.className;
					//				console.log (clsName);
					//				if (clsName.indexOf("loaded")>=0) {
					//					let newClassName = clsName.replace(/loaded/g , '');
					//					console.log ( "newClassName" , newClassName)
					//					ele.setAttribute("class" , newClassName);
					//					let newSrc = ele.getAttribute("data-src");
					//					// ele.removeAttribute("src");
					//					ele.setAttribute("src" , newSrc);
					//				}
					//			}
					//			lazyLoadInstance = new LazyLoad({
					//				elements_selector: '.lazy',
					//				load_delay: 300
					//				// ... more custom settings?
					//			});
					//			console.log ( lazyLoadInstance , 'document.getElementsByClassName("lazy")' , document.getElementsByClassName("lazy"))
					//			lazyLoadInstance && lazyLoadInstance.update(document.getElementsByClassName("lazy"));
				}
			)
		);
	}
	// function toNav(type) {
	// 	setResultType(type);
	// 	conditionSearch({
	// 		index:1,
	// 		limit:10,
	// 		type
	// 	});
	// }
	function inputChange(e) {
		let str = e ? e.trim() : '';
		setSearchStr(str);
		if (!str) {
			setStep(1);
		}
	}
	// 搜索
	function submit() {
		let str = String(searchStr).trim();
		if (!str) {
			return;
		}
		let arr = clone(searchHistoryList);
		arr.unshift(str);
		arr = [...new Set(arr)];
		setSearchHistoryList(clone(arr));
		createCookie('copyright_search', JSON.stringify(arr));
		// fetch search data
		_track({
			trackName: 'toutu_search_page',
			payload: {
				search_key: str,
				page_action_name: 'search-submit'
			}
		});
		dispatch(
			getSearchToutu(
				{
					index: 1,
					limit: 10,
					workType: 1, //类型：1 全部 2：活动 3：图片 4：视频"
					tag: str,
					userId
				},
				data => {
					isEnter = false;
					setStep(3);
					console.log('callback: ', data);
					reloadLazyLoad(lazyLoadInstance);
					//			lazyLoadInstance = new LazyLoad({
					//				elements_selector: '.lazy',
					//				load_delay: 0
					//				// ... more custom settings?
					//			});
					//			lazyLoadInstance && lazyLoadInstance.update(document.getElementsByClassName("lazy"));
				}
			)
		);
	}
	onkeydown = e => {
		if (e.keyCode === 13) {
			if (!isEnter) {
				isEnter = true;
				let dom = e.currentTarget.querySelectorAll('input[type=search]')[0];
				dom.blur();
				submit();
			}
		}
	};
	function reset() {
		setSearchHistoryList([]);
		createCookie('copyright_search', '');
	}
	function cancel() {
		console.log(params, location);
		let pathname = '/vpmobile/copyright/home';
		if (params.ref === '1') {
			pathname = '/vpmobile/copyright/home';
		} else if (params.ref === '2') {
			pathname = '/vpmobile/copyright/events';
		} else if (params.ref === '3') {
			pathname = '/vpmobile/copyright/activitylist';
		} else if (params.ref === '4') {
			pathname = '/vpmobile/copyright/gallery';
		} else if (params.ref === '5') {
			pathname = '/vpmobile/copyright/topic';
		}
		history.push({
			pathname
		});
		// history.goBack();
	}
	function clickWord(word) {
		console.log(word);
		setStep(3);
		setSearchStr(word);
		conditionSearch({
			index: 1,
			limit: pageSize,
			type: 1,
			text: word
		});
	}
	function toActivity(item) {
		//处理微信授权的问题 通过history.push 方式会导致打开activity分享空白
		window.location.href = '/vpmobile/copyright/activity/' + item.id + '/search';
	}
	function remainDaysTip(timestamp) {
		let ms = timestamp - new Date().getTime();
		if (ms <= 0) {
			return '活动已结束';
		}
		return `活动将于${Math.ceil(ms / 1000 / 3600 / 24)}天后结束`;
	}
	const actTypeIcons = {
		1: {
			iconFn: <i className={'iconfont public-benefit'}>&#xe662;</i>,
			text: '公益活动',
			className: 'public-benefit'
		},
		2: {
			iconFn: <i className={'iconfont reward'}>&#xe665;</i>,
			text: '悬赏活动',
			className: 'reward'
		},
		3: {
			iconFn: <i className={'iconfont flash'}>&#xe66b;</i>,
			text: '快闪活动',
			className: 'flash'
		}
	};
	function ActTypeIcon(prop) {
		let item = prop.item;
		let category = item.category;
		if (!category) {
			return '';
		}
		let type = actTypeIcons[category];
		return (
			<span className="act-type">
				{actTypeIcons[item.category].iconFn}
				<span className="text">{actTypeIcons[item.category].text}</span>
			</span>
		);
	}
	let handleLoadMore = resolve => {
		console.log('pageSize', totalCount, pageIndex, pageSize);
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		_track({
			trackName: 'toutu_search_page',
			payload: {
				search_key: searchStr,
				page_action_name: 'search-submit'
			}
		});
		dispatch(
			getSearchToutu(
				{
					index: pageIndex + 1,
					limit: pageSize,
					type: resultType, //类型：1 全部 2：活动 3：图片 4：视频"
					tag: searchStr,
					userId
				},
				() => {
					reloadLazyLoad(lazyLoadInstance);
					//			lazyLoadInstance && lazyLoadInstance.update();
					resolve();
				}
			)
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	function onToidetail(item, index) {
		let top = document.getElementsByClassName('tloader')[0].scrollTop;
		if (item.type === 2) {
			onPlayer({
				id: item.id,
				topicId: item.topicId,
				url: item.thumbVideoUrl,
				type: ''
			});
			return;
		}
		let objectProps = clone(defaultProps);
		let newItems = objectProps.items.filter(item => {
			if (item.type === 2) {
				return false;
			}
			return true;
		});
		let newArray = handleIndexData(contents, index);
		console.log('newArray', newArray);
		history.push({
			pathname: '/vpmobile/copyright/idetail',
			state: {
				defaultProps: newArray, // objectProps,
				index: index, //matchIndex,
				pathname: location.pathname,
				sectionDescription: item.sectionDescription,
				top
			}
		});
		_track({
			trackName: 'toutu_search_page',
			payload: {
				page_action_name: 'search-to-idetail'
			}
		});
		function getCurrentImgInfo(item) {
			console.log(item);
			// let item = items[index - 1];
			let { contentId } = item;
			dispatch(
				getImgInfo({ contentId }, data => {
					_track({
						trackName: 'toutu_search_page',
						payload: {
							...data,
							page_action_name: 'search-imginfo'
						}
					});
					setImgInfo(data);
					console.log('img info', data);
				})
			);
		}
		function onPlayer({ url, type }) {
			const videoJsOptions = {
				autoplay: true,
				controls: true,
				fluid: true,
				controlBar: {
					fullscreenToggle: false
				},
				sources: [
					{
						src: url,
						type: type || 'video/mp4'
					}
				],
				data: {
					id,
					topicId,
					url
				},
				closeCallback: () => {
					setPlayerOptions({});
				}
			};
			setPlayerOptions(videoJsOptions);
		}
	}
	function getCurrentImgInfo(item) {
		console.log(item);
		// let item = items[index - 1];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				_track({
					trackName: 'toutu_idetail_page',
					payload: {
						...data,
						page_action_name: 'idetail-imginfo'
					}
				});
				setImgInfo(data);
				console.log('img info', data);
			})
		);
	}
	function onMore(item, index) {
		console.log(item, index);
		let textArray = ['视频信息', '下载视频', '取消'];
		ActionSheet.showActionSheetWithOptions(
			{
				options: textArray,
				//message: '上传照片、视频',
				maskClosable: true,
				wrapProps: {
					// onTouchStart: e => e.preventDefault()
				}
			},
			buttonIndex => {
				console.log(buttonIndex);
				if (buttonIndex === 0) {
					// alert('视频信息');
					//视频信息
					getCurrentImgInfo(item);
					pageData.isShowInstruction = true;
					setPageData(clone(pageData));
				} else if (buttonIndex === 1) {
					// alert('视频下载');
					//视频下载
					// showQRCode(item);
				}
			}
		);
	}
	function onPraise(item, index) {
		if (!praiseState) {
			return;
		}
		praiseState = false;
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					Modal.alert('提示', '登录过期，是否去登录？', [
						{ text: '再看看', onPress: () => {} },
						{
							text: '去登录',
							onPress: () => {
								window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent(window.location.pathname);
							}
						}
					]);
					return;
				}
				console.log('praise', item);
				dispatch(
					setGalleryImgPraise(
						{
							operation: item.likeStatus === 0 ? 1 : 0,
							postId: item.sectionId,
							userId: baseInfo.id,
							index,
							name: 'search'
						},
						data => {
							praiseState = true;
						},
						data => {
							praiseState = true;
						}
					)
				);
			})
		);
	}
	function uploadDownloadInfo() {
		let item = defaultProps.items[selectIndex];
		//let _index = carouselIndex === -1 ? index : carouselIndex;
		let contentIds = [item.contentId];
		console.log('contentId..', item.contentId);
		let userId = readCookie('copyrightuserId');
		dispatch(
			sendDownloadInfo(
				{
					contentIds,
					userId
				},
				data => {},
				data => {
					console.log('error data', data);
				}
			)
		);
	}
	function showQRCode(url) {
		pageData.isShowDownload = true;
		setPageData({ ...pageData });
		let fd = new FormData();
		fd.append('appId', MINIPROGRAM_APPID);
		// fd.append('downloadUrl', items[_index].originalUrl);
		fd.append('downloadUrl', url);
		dispatch(
			getDownloadQRCode(
				fd,
				data => {
					pageData.isShowQRcodeInstruction = true;
					pageData.QRContent =
						'<div class="qrcode-wrap">' +
						'<img width="186" height="186" src="' +
						data.miniAppQrUrl +
						'" alt="小程序二维码" />' +
						'<div class="tip2">长按识别小程序码下载本图</div>' +
						'</div>';
					setPageData(clone(pageData));
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
					// return '<div class="qrcode-wrap">' + '<img width="162" height="162" src="' + data.miniAppQrUrl + '" alt="小程序二维码" />' + '<div class="tip2">长按识别小程序码下载本图</div>' + '</div>';
					uploadDownloadInfo();
				},
				data => {
					console.log('error data', data);
					Toast.fail('生成小程序码失败');
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
				}
			)
		);
	}
	function dialogQrCodeFooter() {
		pageData.isShowQRcodeInstruction = false;
		pageData.isShowDownload = false;
		setPageData(clone(pageData));
	}
	function onDownload(item, index) {
		setSelectIndex(index);
		// setIsDownload(true);
		setIsDownloadTip(true);
	}
	function onCloseTip() {
		if (isTooBig) {
			setIsTooBig(false);
		}
		setIsDownloadTip(false);
	}
	function onOpenTipNext(url) {
		// setIsTooBig(true);
		setIsDownloadTip(false);
		showQRCode(url);
	}
	function closest(el, selector) {
		const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
		while (el) {
			if (matchesSelector.call(el, selector)) {
				return el;
			}
			el = el.parentElement;
		}
		return null;
	}
	function onClose() {
		setIsDownload(false);
	}
	function onWrapTouchStart(e) {
		if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
			return;
		}
		const pNode = closest(e.target, '.am-modal-content');
		if (!pNode) {
			e.preventDefault();
		}
	}
	let ub = useCallback(
		({ index, limit, type, text, callback }) => {
			if (!text && !searchStr) {
				return;
			}
			_track({
				trackName: 'toutu_search_page',
				payload: {
					search_key: text || searchStr,
					page_action_name: 'search-submit'
				}
			});
			dispatch(
				getSearchToutu(
					{
						index,
						limit: 10,
						workType: params.searchType || 1, //类型：1 全部 2：活动 3：图片 4：视频"
						tag: text || searchStr,
						userId
					},
					() => {
						//alert(1)
						setStep(3);
						// console.log ( "lazyLoadInstance" , lazyLoadInstance)
						reloadLazyLoad(lazyLoadInstance);
//						lazyLoadInstance && lazyLoadInstance.update();
					}
				)
			);
		},
		[dispatch, params, searchStr, lazyLoadInstance, userId]
	);
	useEffect(() => {
		console.log('effectFlag...', effectFlag, changeTab, cache);
		if (!cache || changeTab || (effectFlag === 1 && get(searchToutuData, ['topices', 'length'], 0) === 0 && get(searchToutuData, ['contents', 'length'], 0) === 0)) {
			setCache(true);
			setEffectFlag(2);
			setChangeTab(false);
			ub({
				index: 1,
				limit: 10
			});
		} else if (effectFlag === 1 && cache) {
			//cache的时候数据没有变化，只是渲染
			setEffectFlag(2);
			setStep(3);
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
			lazyLoadInstance && lazyLoadInstance.update();
		}
	}, [effectFlag, ub, cache, props, lazyLoadInstance, changeTab, searchToutuData]);
	let ref = params.ref || 1;
	// alert(resultType)
	console.log('ssss..', resultType);
	console.log(typeof resultType);
	console.log('searchToutuData..?', searchToutuData, get(searchToutuData, ['topices', 'length'], ''), get(searchToutuData, 'topices', []));
	return (
		<div className="copyright copyright-search">
			<header className="search-box">
				{/* <i className="search-icon" onClick={submit}>&#xe65a;</i> */}
				<Icon className="search-icon" type="search" size="sm" onClick={submit}></Icon>
				<div className="box-inner">
					<div className="input-wrap" onKeyDown={onkeydown}>
						<form action="#">
							<InputItem className="search-inner" type="search" clear onChange={inputChange} value={searchStr} placeholder="搜索图片、视频、活动"></InputItem>
						</form>
					</div>
					<span className="search-cancel" onClick={cancel}>
						取消
					</span>
				</div>
			</header>
			<section className={`record-wrap ${step !== 1 ? 'hide' : null}`}>
				<div className="record">
					<div className="record-tip">
						<div className="">历史搜索</div>
						<div className="reset" onClick={reset}>
							清空历史
						</div>
					</div>
					<div className="record-box">
						{get(searchHistoryList, 'length', '') ? (
							searchHistoryList.map((item, index) => {
								return (
									<div className="record-item" key={'history-' + index} onClick={() => clickWord(item)}>
										{item}
									</div>
								);
							})
						) : (
							<div className="record-none">暂无搜索记录</div>
						)}
					</div>
				</div>
				{/* <div className="hot-tag">
					<div className="title">热门标签</div>
					<div className="tag-box">
						<div className="tag-item" onClick={clickWord}>
							#武汉加油
						</div>
						<div className="tag-item" onClick={clickWord}>
							#武汉加油
						</div>
						<div className="tag-item" onClick={clickWord}>
							#武汉加油武汉加油
						</div>
						<div className="tag-item" onClick={clickWord}>
							#武汉加油
						</div>
						<div className="tag-item" onClick={clickWord}>
							#武汉加油
						</div>
					</div>
				</div> */}
			</section>
			{/* <section className={`word-matched ${step !== 2 ? 'hide' : null}`}>
				<div className="word-item" onClick={clickWord}>
					<div className="word-txt">
						<Icon className="search-icon" type="search" size='sm'/>
						<span>
							<span className="input-txt">武汉</span>疫情
						</span>
					</div>
				</div>
				<div className="word-item">
					<div className="word-txt">
						<Icon className="search-icon" type="search" size='sm'/>
						<span>
							<span className="input-txt">武汉</span>疫情
						</span>
					</div>
				</div>
				<div className="word-item">
					<div className="word-txt">
						<Icon className="search-icon" type="search" size='sm'/>
						<span>武汉疫情</span>
					</div>
				</div>
			</section> */}
			<section className={`result ${step !== 3 ? 'vsblty-hide' : null}`}>
				<div className="result-nav">
					<div
						className={`nav-item ${resultType === 1 ? 'active' : null}`}
						onClick={() => {
							setChangeTab(true);
							setResultType(1);
							history.push({
								pathname: `/vpmobile/copyright/search/${ref}/1`
							});
							// toNav(1);
						}}>
						全部
					</div>
					<div className="nav-item line">|</div>
					<div
						className={`nav-item ${resultType === 2 ? 'active' : null}`}
						data-cc={resultType}
						onClick={() => {
							setChangeTab(true);
							setResultType(2);
							history.push({
								pathname: `/vpmobile/copyright/search/${ref}/2`
							});
							//toNav(2);
						}}>
						活动
					</div>
					<div className="nav-item line">|</div>
					<div
						className={`nav-item ${resultType === 3 ? 'active' : null}`}
						onClick={() => {
							setChangeTab(true);
							setResultType(3);
							history.push({
								pathname: `/vpmobile/copyright/search/${ref}/3`
							});
							// toNav(3);
						}}>
						图片
					</div>
					<div className="nav-item line">|</div>
					<div
						className={`nav-item ${resultType === 4 ? 'active' : null}`}
						onClick={() => {
							setChangeTab(true);
							setResultType(4);
							history.push({
								pathname: `/vpmobile/copyright/search/${ref}/4`
							});
							// toNav(4);
						}}>
						视频
					</div>
				</div>
				<Tloader
					initializing={2}
					onRefresh={handleRefresh}
					hasMore={true}
					onLoadMore={handleLoadMore}
					autoLoadMore={!pageData.albumFinishAll /*false不会触发onLoadMore*/}
					className="tloader some class">
					<div className="">
						{get(searchToutuData, ['topices', 'length'], 0) ? (
							<div className="activity">
								<div className="activity-tit">
									<span className="activity-word">与{searchStr}相关的活动</span>
									<span
										className="activity-all"
										onClick={() => {
											history.push({
												pathname: `/vpmobile/copyright/search/${ref}/2`
											});
											// toNav(2);
										}}>
										全部活动 &gt;
									</span>
								</div>
								<div className="activity-carousel">
									{get(searchToutuData, ['topices', 'length'], 0) && resultType === 1 ? (
										<Carousel infinite cellSpacing={10} slideWidth={1}>
											{get(searchToutuData, 'topices', []).map((item = {}, index) => (
												<div className="carousel-item" key={index}>
													<div to={'/vpmobile/copyright/activity/' + item.id + '?' + item.id} onClick={toActivity.bind(this, item)}>
														<div className="item-box">
															<img alt="" className="cover" src={item.url} />
															<h3>
																<span className="iconfont topic"></span>
																{item.name}
															</h3>
															<p className="des">{remainDaysTip(moment(item.endTime))}</p>
															{item.endTime > new Date().getTime() ? <div className="button">立即参与</div> : <div className="button over">活动已结束</div>}
															<ActTypeIcon item={item} />
														</div>
													</div>
												</div>
											))}
										</Carousel>
									) : (
										''
									)}
								</div>
							</div>
						) : (
							''
						)}
						{get(searchToutuData, ['contents', 'length'], 0) && resultType !== 2 ? (
							<div className="vfalls-wrap">
								<Vfalls {...defaultProps} isDesc={true} onClick={onToidetail} onMore={onMore} onDownload={onDownload} onPraise={onPraise} isSearch update={isUpdate} />
							</div>
						) : (
							''
						)}
						{resultType !== 2 ? pageIndex * pageSize < totalCount ? <Loading /> : <div className="more-text"></div> : ''}
						{get(searchToutuData, ['topices', 'length'], 0) && resultType === 2 ? (
							<section className="activities">
								<h2>
									热门活动<span className="op">原创主题影像征集</span>
								</h2>
								<ul>
									{get(searchToutuData, 'topices', []).map((item = {}, index) => (
										<li key={'home-sport-' + index}>
											<div to={'/vpmobile/copyright/activity/' + item.id + '?' + item.id} onClick={toActivity.bind(this, item)}>
												<div className="item-box">
													<img alt="" className="cover" src={item.url} />
													<h3>
														<span className="iconfont topic"></span>
														{item.name}
													</h3>
													<p className="des">{remainDaysTip(moment(item.endTime))}</p>
													{item.endTime > new Date().getTime() ? <div className="button">立即参与</div> : <div className="button over">活动已结束</div>}
													<ActTypeIcon item={item} />
												</div>
											</div>
										</li>
									))}
								</ul>
								{pageIndex * pageSize < totalCount ? <Loading /> : <div className="more-text"></div>}
							</section>
						) : (
							''
						)}
					</div>
					{!get(searchToutuData, ['topices', 'length'], 0) && !get(searchToutuData, ['contents', 'length'], 0) ? (
						<div className="no-data">
							<div>
								<img src={emptyImg} className="App-empty" alt="empty" />
							</div>
							<div>未找到相关内容</div>
						</div>
					) : (
						''
					)}
				</Tloader>
			</section>
			{pageData.isShowQRcodeInstruction ? <TextDialog title="照片下载" text={pageData.QRContent} clickFooter={dialogQrCodeFooter} footer={'关闭'} /> : ''}
			{isDownloadTip ? <DownloadTip isDownloadTip={isDownloadTip} imgInfo={defaultProps.items} index={selectIndex} onClose={onCloseTip} onOpenTipNext={onOpenTipNext}></DownloadTip> : ''}
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
		</div>
	);
};
export { CopyrightSearch };
